import {
  FETCH_ACCESS_FAILURE,
  FETCH_ACCESS_LOADING,
  FETCH_ACCESS_SUCCESS,
  ADD_ACCESS_FAILURE,
  ADD_ACCESS_SUCCESS,
  ADD_ACCESS_LOADING,
  UPDATE_ACCESS_FAILURE,
  UPDATE_ACCESS_LOADING,
  UPDATE_ACCESS_SUCCESS,
  FETCH_GROUP_ACCESS_LOADING,
  FETCH_GROUP_ACCESS_SUCCESS,
  FETCH_GROUP_ACCESS_FAILURE,
  FETCH_ZONE_PRIORITIES_WITH_USERS_LOADING,
  FETCH_ZONE_PRIORITIES_WITH_USERS_SUCCESS,
  FETCH_ZONE_PRIORITIES_WITH_USERS_FAILURE,
  DELETE_INDIVIDUAL_ACCESS_SUCCESS,
  DELETE_INDIVIDUAL_ACCESS_LOADING,
  DELETE_INDIVIDUAL_ACCESS_FAILURE
} from '../Types/accessTypes';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;
export const getIndividualAccessByUser = id => {
  return dispatch => {
    dispatch({
      type: FETCH_ACCESS_LOADING
    });
    api
      .get(`${API_WP}IndividualAccess/searchByUser/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_ACCESS_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_ACCESS_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const addIndividualAccess = data => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({ type: ADD_ACCESS_LOADING });
      api
        .post(`${API_WP}IndividualAccess/add`, { data })
        .then(() => {
          dispatch({
            type: ADD_ACCESS_SUCCESS
            // payload: response.data.data
          });
          dispatch(getIndividualAccessByUser(data.User));
          resolve({ status: 200 });
        })
        .catch(error => {
          dispatch({
            type: ADD_ACCESS_FAILURE,
            payload: error.message
          });
          reject(error.message);
        });
    });
  };
};
export const addIndividualYAccess = data => {
  return dispatch => {
    dispatch({ type: ADD_ACCESS_LOADING });
    api
      .post(`${API_WP}IndividualAccess/add`, { data })
      .then(response => {
        dispatch({
          type: ADD_ACCESS_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: ADD_ACCESS_FAILURE,
          payload: error.message
        });
      });
  };
};

export const updateIndividualAccess = (id, data) => {
  return dispatch => {
    dispatch({ type: UPDATE_ACCESS_LOADING });
    api
      .put(`${API_WP}IndividualAccess/updateUserAccess/${id}`, data)
      .then(() => {
        dispatch({
          type: UPDATE_ACCESS_SUCCESS
          // payload: response.data.data
        });
        dispatch(getIndividualAccessByUser(id));
      })
      .catch(error => {
        dispatch({
          type: UPDATE_ACCESS_FAILURE,
          payload: error.message
        });
      });
  };
};

export const updateUserAccessPriority = (id, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({ type: UPDATE_ACCESS_LOADING });
      api
        .put(`${API_WP}IndividualAccess/updateUserAccessPriority/${id}`, data)
        .then(() => {
          dispatch(getIndividualAccessByUser(id));
          resolve({ status: 200 });
        })
        .catch(error => {
          dispatch({
            type: UPDATE_ACCESS_FAILURE,
            payload: error.message
          });
          reject(error.message);
        });
    });
  };
};

export const updateUserAccessYPriority = (id, data) => {
  return async dispatch => {
    dispatch({ type: UPDATE_ACCESS_LOADING });
    try {
      await api.put(`${API_WP}IndividualAccess/updateUserAccess/${id}`, data);
      dispatch({ type: UPDATE_ACCESS_SUCCESS });
      await dispatch(getIndividualAccess());
    } catch (error) {
      dispatch({
        type: UPDATE_ACCESS_FAILURE,
        payload: error.message
      });
    }
  };
};
export const getAccessByGroup = id => {
  return dispatch => {
    dispatch({ type: FETCH_GROUP_ACCESS_LOADING });
    api
      .get(`${API_WP}Zone/GroupAccess/getAccessByGroup/${id}`)
      .then(res => {
        dispatch({
          type: FETCH_GROUP_ACCESS_SUCCESS,
          payload: res.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: FETCH_GROUP_ACCESS_FAILURE,
          payload: error.message
        });
      });
  };
};

export const getIndividualAccess = () => {
  return dispatch => {
    dispatch({
      type: FETCH_ACCESS_LOADING
    });
    api
      .get(`${API_WP}IndividualAccess/getAll`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_ACCESS_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_ACCESS_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const getZonePrioritiesWithUsers = () => {
  return async dispatch => {
    dispatch({ type: FETCH_ZONE_PRIORITIES_WITH_USERS_LOADING });
    try {
      const response = await api.get(`${API_WP}Zone/getAllZones`);
      dispatch({
        type: FETCH_ZONE_PRIORITIES_WITH_USERS_SUCCESS,
        payload: response.data.data
      });
      return response.data.data;
    } catch (error) {
      dispatch({
        type: FETCH_ZONE_PRIORITIES_WITH_USERS_FAILURE,
        payload: error.message
      });
      throw error;
    }
  };
};

export const deleteIndividualAccess = accessId => {
  return dispatch => {
    if (!accessId) {
      throw new Error('Access ID is missing');
    }
    dispatch({ type: DELETE_INDIVIDUAL_ACCESS_LOADING });
    return api
      .delete(`${API_WP}IndividualAccess/deleteIndividual/${accessId}`)
      .then(response => {
        dispatch({
          type: DELETE_INDIVIDUAL_ACCESS_SUCCESS,
          payload: accessId
        });
        return response.data;
      })
      .catch(error => {
        console.error('Delete individual access error:', error);
        dispatch({
          type: DELETE_INDIVIDUAL_ACCESS_FAILURE,
          payload: error.message
        });
        throw error;
      });
  };
};
